import { Field, Form, Formik } from "formik";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React from "react";
import ResponsiveHeader from "pages/_components/header";
import Checkbox from "pages/_components/Checkbox";
import GridTable from "pages/_components/GridTable/GridTable";
import * as configUtils from "util/config";
import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { useDispatch, useSelector } from "react-redux";
import { actions as comexActions } from "reducers/comex";
import { push } from "connected-react-router";
import ComexStepper from "./_components/ComexStepper";

const Step2Comex = ({ isDesktop }) => {
    const FORM_ID = "comex.payment";
    const dispatch = useDispatch();

    const comexPayments = configUtils.getArray("comex.payments.option");
    const comexTransfer = useSelector((state) => state.comex.comexTransfer) || {};

    const handleCheckboxChange = (setFieldValue, selectedPayment) => {
        setFieldValue(selectedPayment, true);

        comexPayments.forEach((payment) => {
            if (payment !== selectedPayment) {
                setFieldValue(payment, false);
            }
        });
    };

    const handleSubmit = (values) => {
        const selectedPayment = Object.keys(values).find((key) => values[key]) || null;
        dispatch(
            comexActions.setComexTransfer({
                ...comexTransfer,
                selectedPayment,
            }),
        );
        dispatch(push("/comex/transfer"));
    };

    return (
        <>
            {isDesktop && <ComexStepper isDesktop={isDesktop} currentStep={2} />}
            <Notification scopeToShow="Step2Comex" />
            <ResponsiveHeader ticket metaTitle="transfers.comex.title" backLinkTo="/comex/concept" />

            <MainContainer>
                {!isDesktop && <ComexStepper isDesktop={isDesktop} currentStep={2} />}
                <I18n id="comex.payment.option.title" component="h2" />
                <Formik
                    initialValues={comexPayments.reduce(
                        (acc, payment) => ({
                            ...acc,
                            [payment]: comexTransfer.selectedPayment === payment,
                        }),
                        {},
                    )}
                    onSubmit={(values) => handleSubmit(values)}>
                    {({ values, handleChange, setFieldValue }) => (
                        <>
                            <Form onChange={handleChange}>
                                <GridTable className="form">
                                    <GridTable.Container columns={12} columnsTemplate="fixed">
                                        {comexPayments.map((payment, index) => (
                                            <GridTable.Data
                                                columnStart={2}
                                                columnWidth={10}
                                                rowStart={index + 1}
                                                key={payment}>
                                                <Field
                                                    component={Checkbox}
                                                    idForm={FORM_ID}
                                                    name={payment}
                                                    checked={values[payment] || false}
                                                    onChange={() => handleCheckboxChange(setFieldValue, payment)}
                                                    labelClassName="payments-checkbox"
                                                    labelText={`comex.payment.${payment}.detail.label`}
                                                />
                                            </GridTable.Data>
                                        ))}
                                    </GridTable.Container>
                                </GridTable>
                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button type="submit" className="btn-primary" label="global.continue" />
                                    </Col>
                                </Row>
                            </Form>
                        </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

export default Step2Comex;

Step2Comex.propTypes = {
    isDesktop: bool.isRequired,
};
